module.exports = __webpack_public_path__ + "img/sage-accounting-export.b9116f0a.svg";